import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.2594 4L16 4.62859L8 13L0 4.62859L0.740567 4L8 11.5965L15.2594 4Z",
		fill: "black"
	})
});
export default SvgChevron;
